// Convierte un dataURI (png/jpg) a dataURI JPEG usando canvas en el navegador
// Retorna Promise<string|null>
export function convertDataUriToJpeg(dataUri, quality = 0.92) {
  return new Promise((resolve) => {
    try {
      if (typeof dataUri !== 'string' || !dataUri.startsWith('data:image/')) {
        return resolve(null);
      }
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || img.width;
          canvas.height = img.naturalHeight || img.height;
          const ctx = canvas.getContext('2d');
          // Fondo blanco para evitar negro por canal alpha
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          const jpegDataUri = canvas.toDataURL('image/jpeg', quality);
          resolve(jpegDataUri);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = dataUri;
    } catch (_) {
      resolve(null);
    }
  });
}

export default { convertDataUriToJpeg };
